en:
  NEWSENTRY:
    type_all: 'All'
    type_news: 'News'
    type_event: 'Event'
    type_label: 'Type'
    singular_name: 'News Entry'
    plural_name: 'News Entries'
    read_more: 'Read more'
    read_less: 'Read less'
  BIRTHDAY:
    learn_more: 'Learn more'
    information: 'Information'
    group_size: 'Group size'
    costs: 'Costs'
    duration: 'Duration'
    hours: 'hours'
    additional_info: 'Additional information'
    age: 'Age'
    years: 'years'
    contact_title: 'Contact for more information and registration'
    email: 'E-Mail'
    close: 'Close'
    Telefon: 'Telephone'
  VISITDETAILS:
    opening_hours: 'Opening Hours'
    prices: 'Prices'
  NAV:
    brand_aria: 'Homepage of Schloss Ahrensburg'
    brand_img_alt: 'Schloss Ahrensburg Logo'
    submenu_open: 'Open submenu'
    lang_change: 'Change language'
    lang_link: 'Switch to'
    lang_menu: 'Languages'
  BREADCRUMB:
    nav_aria: 'Breadcrumb'
  BUTTON:
    link_aria: 'Link to'
  FOOTER:
    instagram_alt: 'Instagram logo'
    facebook_alt: 'Facebook logo'
  NEWSLIST:
    pagination_nav: 'Page navigation'
    prev_page: 'Previous page'
    next_page: 'Next page'
